import Api from '../api';
import {
  GET_ACCOUNT_STATUS, GET_ACCOUNT_STATUS_URL,
  TRANSITION_ACCOUNT, TRANSITION_ACCOUNT_URL,
  GET_STATUS_HISTORY, GET_STATUS_HISTORY_URL,
  GET_ACCOUNT_SUBSCRIPTIONS, GET_ACCOUNT_SUBSCRIPTIONS_URL,
  GET_ACCOUNT_ENTITLEMENTS, GET_ACCOUNT_ENTITLEMENTS_URL,
  LIST_LIFECYCLE_PLANS, LIST_LIFECYCLE_PLANS_URL,
} from '../lib/constant';
import {handleAPIDispatch} from '../lib/utils';

export function getAccountStatus(orgId) {
  const url = GET_ACCOUNT_STATUS_URL.replace('{orgId}', orgId);
  const request = Api.get(url);
  return handleAPIDispatch(request, GET_ACCOUNT_STATUS);
}

export function transitionAccount(orgId, newStatus, reason, initiatedBy) {
  const url = TRANSITION_ACCOUNT_URL.replace('{orgId}', orgId);
  const request = Api.post(url, { newStatus, reason, initiatedBy });
  return handleAPIDispatch(request, TRANSITION_ACCOUNT);
}

export function getStatusHistory(orgId, page, perPage) {
  let url = GET_STATUS_HISTORY_URL.replace('{orgId}', orgId);
  if (page || perPage) {
    const params = [];
    if (page) params.push(`pagination.page=${page}`);
    if (perPage) params.push(`pagination.perPage=${perPage}`);
    url += '?' + params.join('&');
  }
  const request = Api.get(url);
  return handleAPIDispatch(request, GET_STATUS_HISTORY);
}

export function getAccountSubscriptions(orgId) {
  const url = GET_ACCOUNT_SUBSCRIPTIONS_URL.replace('{orgId}', orgId);
  const request = Api.get(url);
  return handleAPIDispatch(request, GET_ACCOUNT_SUBSCRIPTIONS);
}

export function getAccountEntitlements(orgId) {
  const url = GET_ACCOUNT_ENTITLEMENTS_URL.replace('{orgId}', orgId);
  const request = Api.get(url);
  return handleAPIDispatch(request, GET_ACCOUNT_ENTITLEMENTS);
}

export function listLifecyclePlans() {
  const request = Api.get(LIST_LIFECYCLE_PLANS_URL);
  return handleAPIDispatch(request, LIST_LIFECYCLE_PLANS);
}
